export default __webpack_public_path__ + "static/media/chocolate-nuts.a394f951.png";